import { useState } from "react";
import { ChevronDown, Table2 } from "lucide-react";
import PricingMatrixGrid from "./PricingMatrixGrid";

const CollapsibleMatrix = ({ sessionId, productId, productName, defaultSizeId, defaultPaperId }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full" data-testid="collapsible-matrix">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 px-4 py-2.5 rounded-sm transition"
        style={{
          background: open ? "var(--ups-ink)" : "#fff",
          color: open ? "#FFB500" : "var(--ups-ink)",
          border: `1px solid ${open ? "var(--ups-ink)" : "var(--ups-border)"}`,
        }}
        data-testid="matrix-toggle"
        aria-expanded={open}
      >
        <div className="flex items-center gap-2 min-w-0">
          <Table2 size={14} className="shrink-0" />
          <div className="text-left min-w-0">
            <div className="text-[11px] font-bold uppercase tracking-[0.16em]">
              {open ? "Hide" : "Show"} Volume Pricing Table
            </div>
            <div className={`text-[10px] font-mono ${open ? "opacity-70" : "text-[color:var(--ups-subtext)]"} truncate`}>
              Compare quantities &amp; papers · hover to see your partner price
            </div>
          </div>
        </div>
        <ChevronDown
          size={16}
          className="shrink-0 transition-transform"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
        />
      </button>

      {open && (
        <PricingMatrixGrid
          sessionId={sessionId}
          productId={productId}
          productName={productName}
          defaultSizeId={defaultSizeId}
          defaultPaperId={defaultPaperId}
        />
      )}
    </div>
  );
};

export default CollapsibleMatrix;
